import { render, staticRenderFns } from "./connect-magic-into-one-world.vue?vue&type=template&id=532b4e65&scoped=true&"
import script from "./connect-magic-into-one-world.vue?vue&type=script&lang=js&"
export * from "./connect-magic-into-one-world.vue?vue&type=script&lang=js&"
import style0 from "./connect-magic-into-one-world.vue?vue&type=style&index=0&id=532b4e65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532b4e65",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
